import { render, staticRenderFns } from "./AccountHolderExpenseInformationRequest.vue?vue&type=template&id=5dda2cdf&scoped=true"
import script from "./AccountHolderExpenseInformationRequest.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExpenseInformationRequest.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderExpenseInformationRequest.vue?vue&type=style&index=0&id=5dda2cdf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dda2cdf",
  null
  
)

export default component.exports